export const ACTIVATION_REPORT_LIST = "ACTIVATION_REPORT_LIST";
export const ACTIVATION_REPORT_SUCCESSFULL = "ACTIVATION_REPORT_SUCCESSFULL";
export const ACTIVATION_REPORT_FAILED = "ACTIVATION_REPORT_FAILED";
export const RESET_ACTIVATION_REPORT_PAGE="RESET_ACTIVATION_REPORT_PAGE";
